import { Component } from '@angular/core'

@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  standalone: false
})
export class ProvidersComponent {}
